const addItemToCar = (state, item) => {

  item.forEach((it)=>{

    state.car.push(it)
    console.log("aqui es donde hay q chambear", item)

  })
};

const removeItemFromCar = (state, index) => {
  state.car.splice(index, 1)
};

const cleanCar = (state) => {
  state.car = []
};

const setStorageMode = (state, mode) => {
  state.storageMode = mode;
};

export default {
  addItemToCar,
  removeItemFromCar,
  cleanCar,
  setStorageMode,
};




// WEBPACK FOOTER //
// ./src/store/modules/car/mutations.js